import RedactionSearchPanel from './RedactionSearchPanelContainer';

export default RedactionSearchPanel;